import { render, staticRenderFns } from "./BillingAddressEdit.vue?vue&type=template&id=cb21db26&"
import script from "./BillingAddressEdit.vue?vue&type=script&lang=js&"
export * from "./BillingAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports